import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Features.css';
import { platformsConfig } from '../platformConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';

function PlatformCard({ platform, index }) {
  const navigate = useNavigate();

  const handlePlatformClick = (platform) => {
    if (platform.status === 'live') {
      window.scrollTo(0, 0);        // reset scroll

      navigate(`/${platform.platformType}`);
    }
  };

  return (
    <motion.div
      className="ULTHOME-platform-card-item"
      style={{
        cursor: platform.status === 'live' ? 'pointer' : 'default',
        opacity: platform.status === 'live' ? 1 : 0.5
      }}
      onClick={() => handlePlatformClick(platform)}
      initial={{ opacity: 0 }}
      animate={{ opacity: platform.status === 'live' ? 1 : 0.5 }}
      transition={{ duration: 0.5, delay: 1.2 + index * 0.2 }}
    >
      <FontAwesomeIcon icon={platform.icon} className="ULTHOME-platform-icon" />
      <h3 className="ULTHOME-platform-title">{platform.shortName}</h3>
      <p className="ULTHOME-platform-subtitle">{platform.category}</p>
      <p className="ULTHOME-platform-description">{platform.description}</p>

      {platform.stats && (
      <div
        className="ULTHOME-platform-metrics"
        dangerouslySetInnerHTML={{
          __html: Object.entries(platform.stats)
            .slice(0, 2)
            .map(([key, value], i) => `${value} ${key}${i === 0 ? '<br />' : ''}`)
            .join(' ')
        }}
      />
      )}
      {platform.status === 'live' && (
        <div className="ULTHOME-platform-arrow"><FontAwesomeIcon icon={faChevronRight} /></div>
      )}
    </motion.div>
  );
}

function Features() {
  return (
    <div className="platforms-section">
      <div className="features-gradient-overlay"></div>
      <div className="platforms-header">
        <div className="platforms-badge">
          <span className="badge-dot"></span>
          Phenome Atlas
        </div>
        <h2 className="platforms-title">
          Atlas  Overview
        </h2>
        <p className="platforms-subtitle">
          Explore our integrated ecosystem of specialized omics datasources, each designed to unlock
          unique biological insights through cutting-edge AI and data analysis capabilities.
        </p>
      </div>

      <div className="platforms-container">
        <div className="platforms-grid">
          {platformsConfig.map((platform, index) => (
            <PlatformCard
              key={platform.id}
              platform={platform}
              index={index}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Features; 